const isElectron = () => process.env.PLATFORM !== 'website';

const isDev = () => process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'dev';

const isStaging = () => process.env.MODE === 'staging';

// Webpack injection.
const isAcquisitionDemo = (store) =>
  store.getState()?.constructorConfiguration?.isDemoModeEnabled ||
  // eslint-disable-next-line no-undef
  globalThis.IS_ACQUISITION_DEMO ||
  // eslint-disable-next-line no-undef
  IS_ACQUISITION_DEMO;

// Webpack injection.
const isAcquisitionTelemetryDemo = (store) =>
  store.getState()?.constructorConfiguration?.isTelemetryDemoEnabled ||
  // eslint-disable-next-line no-undef
  globalThis.IS_ACQUISITION_TELEMETRY_DEMO ||
  // eslint-disable-next-line no-undef
  IS_ACQUISITION_TELEMETRY_DEMO ||
  process.env.IS_ACQUISITION_TELEMETRY_DEMO;

const getAppName = () => process.env.APP_NAME;

module.exports = {
  isElectron,
  isDev,
  isStaging,
  getAppName,
  isAcquisitionDemo,
  isAcquisitionTelemetryDemo,
};
